import React, { useEffect, useState } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import Logo from './Logo';

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [activeSection, setActiveSection] = useState('');

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const handleAnchorClick = function (e) {
            const href = this.getAttribute('href');
            if (href !== '#' && href !== '') {
                e.preventDefault();
                const target = document.querySelector(href);
                if (target) {
                    const offset = 180; // Larger offset to ensure sections aren't covered by navbar
                    const targetPosition = target.offsetTop - offset;
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            }
        };

        const handleScroll = () => {
            const sections = document.querySelectorAll('section[id]');
            const navLinks = document.querySelectorAll('.nav-links a');

            let currentSection = '';

            sections.forEach(section => {
                const sectionTop = section.offsetTop - 120;
                const sectionHeight = section.offsetHeight;
                if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
                    currentSection = section.getAttribute('id');
                }
            });

            setActiveSection(currentSection);

            navLinks.forEach(link => {
                link.classList.remove('active');
                if (link.getAttribute('href') === `#${currentSection}`) {
                    link.classList.add('active');
                }
            });
        };

        const anchors = document.querySelectorAll('a[href^="#"]');
        anchors.forEach(anchor => {
            anchor.addEventListener('click', handleAnchorClick);
        });

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            anchors.forEach(anchor => {
                anchor.removeEventListener('click', handleAnchorClick);
            });
        };
    }, []);

    return (
        <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
            <div className="navbar-container">
                <a href="/" className="logo">
                    <Logo />
                </a>
                <ul className="nav-links">
                    <li>
                        <a href="/#how-it-works" className={activeSection === 'how-it-works' ? 'active' : ''}>
                            How It Works
                        </a>
                    </li>
                    <li>
                        <a href="/#services" className={activeSection === 'services' ? 'active' : ''}>
                            Services
                        </a>
                    </li>

                    <li>
                        <a href="/#team" className={activeSection === 'team' ? 'active' : ''}>
                            Why Choose Us
                        </a>
                    </li>
                    <li>
                        <a href="/#testimonials" className={activeSection === 'testimonials' ? 'active' : ''}>
                            Success Stories
                        </a>
                    </li>
                    <li>
                        <a href="/#faq" className={activeSection === 'faq' ? 'active' : ''}>
                            FAQ
                        </a>
                    </li>
                    <li>
                        <a href="/login" className="nav-btn-secondary" style={{
                            marginRight: '1rem',
                            padding: '0.5rem 1rem',
                            borderRadius: '8px',
                            border: '1px solid var(--color-primary)',
                            color: 'var(--color-primary)',
                            fontWeight: '600',
                            transition: 'all 0.2s',
                            background: 'transparent'
                        }}>
                            Sign In
                        </a>
                    </li>
                    <li>
                        <a href="/#contact" className={`nav-cta ${activeSection === 'contact' ? 'active' : ''}`}>
                            Contact Us <FaArrowRight />
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;
